<template>
  <div class="px-0 mx-5 mb-16">
    <div class="row">
      <div class="col-md-12">
        <v-stepper v-model="step">
            <v-stepper-header>
                <v-stepper-step :complete="step > 1" step="1">
                    DATOS DE FACTURACIÓN
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="step > 2" step="2">
                    DATOS DE PAGO
                </v-stepper-step>
            </v-stepper-header>
            <v-stepper-items>
                <v-stepper-content step="1">
                    <v-form ref="form_billing_data" class="form_billing_data">  
                    <v-row>
                        <v-col cols="12" md="6" >
                            <v-card class="mx-auto">
                                <div class='white--text text-md-subtitle-1 py-2 px-2 primary'>
                                    <b>
                                        <v-icon class="white--text" style="position: relative;top: -3px;">mdi mdi-file-document</v-icon> SUS DATOS DE FACTURACIÓN
                                    </b>
                                </div>          
                                <div class="mt-3">
                                    <v-select
                                        v-model="deliveryType"
                                        :items="deliveryTypes"
                                        item-value="type"
                                        item-text="name"
                                        :prepend-inner-icon=iconTypeDelivey
                                        label="Tipo de entrega"
                                        dense
                                        outlined
                                        @change="deliveryType == 'delivery' ? iconTypeDelivey= 'mdi mdi-truck' : iconTypeDelivey= 'mdi mdi-store'"
                                    ></v-select>
                                </div>
                                <v-row>
                                    <v-col cols="12" sm="6">
                                        <v-text-field
                                            v-model="identification"
                                            :rules="ruleRequire"
                                            outlined
                                            dense
                                            rounded
                                            append-icon="mdi mdi-magnify"
                                            @click:append="searchClient"
                                        >
                                        <template v-slot:label>
                                            <span class="gray--text font-title">
                                            <i>Identificación *</i></span>
                                        </template>
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <div >
                                            <v-select
                                                v-model="identificationType"
                                                :items="identificationTypes"
                                                item-value="name"
                                                item-text="name"
                                                label="Tipo de identificación"
                                                dense
                                                outlined
                                            ></v-select>
                                        </div>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="6" class="pt-0">
                                        <v-text-field
                                            v-model="firstName"
                                            :rules="ruleRequire"
                                            outlined
                                            dense
                                            rounded
                                        >
                                            <template v-slot:label>
                                                <span class="gray--text font-title">
                                                <i>Nombres *</i></span
                                                >
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" class="pt-0">
                                        <v-text-field
                                            v-model="lastName"
                                            :rules="ruleRequire"
                                            outlined
                                            dense
                                            rounded
                                        >
                                        <template v-slot:label>
                                            <span class="gray--text font-title">
                                            <i>Apellidos *</i></span
                                            >
                                        </template>
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" class="pt-0">
                                        <v-text-field
                                            type="email"
                                            v-model="email"
                                            :rules="ruleRequire"
                                            label="Email *"
                                            outlined
                                            dense
                                            rounded
                                        >
                                        <template v-slot:label>
                                            <span class="gray--text font-title">
                                            <i>Email *</i></span
                                            >
                                        </template>
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" class="pt-0">
                                        <v-text-field
                                            v-model="tlf"
                                            :rules="ruleRequire"
                                            outlined
                                            dense
                                            rounded
                                        >
                                            <template v-slot:label>
                                                <span class="gray--text font-title">
                                                <i>Teléfono *</i></span
                                                >
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                                <v-btn color="primary" block @click="validDatashipping"> 
                                    <b> <v-icon>mdi mdi-arrow-right-bold-circle</v-icon> IR AL PAGO </b>
                                </v-btn>      
                            </v-card>                              
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-card class="mx-auto">
                                <div class='white--text text-md-subtitle-1 py-2 px-2 primary'>
                                    <b>
                                        <v-icon class='white--text' style="position: relative;top: -3px;">mdi mdi-account-star</v-icon> PERSONA QUE RECIBE EL PEDIDO
                                    </b>
                                </div>  
                                <v-row>
                                    <v-col cols="12" sm="6">
                                        <v-text-field
                                            v-model="firstNameReceiver"
                                            :rules="deliveryType =='delivery' ? ruleRequire : []"
                                            outlined
                                            dense
                                            rounded
                                        >
                                        <template v-slot:label>
                                            <span class="gray--text font-title">
                                                <i>Nombres *</i>
                                            </span>
                                        </template>
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-text-field
                                            v-model="lastNameReceiver"
                                            :rules="deliveryType =='delivery' ? ruleRequire : []"
                                            outlined
                                            dense
                                            rounded
                                        >
                                            <template v-slot:label>
                                                <span class="gray--text font-title">
                                                    <i>Apellidos *</i>
                                                </span>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" class="pt-0">
                                        <v-select
                                            v-model="directionReceiver"
                                            :items="directionsClient"
                                            :rules="deliveryType =='delivery' ? ruleRequire : []"
                                            append-outer-icon="mdi mdi-plus-circle"
                                            item-value="contact_mech_id"
                                            item-text="direction"
                                            dense
                                            outlined
                                            @change="setDirectionInputs"
                                        >
                                            <template v-slot:label>
                                                <span class="gray--text font-title">
                                                    <i>Sus direcciones</i>
                                                </span>
                                            </template>
                                        </v-select>
                                    </v-col>
                                    <v-col cols="12" sm="6" class="pt-0">
                                        <v-select
                                            v-model="provinceReceiver"
                                            :items="provinces"
                                            :rules="deliveryType =='delivery' ? ruleRequire : []"
                                            item-value="geo_id"
                                            item-text="geo_name"
                                            dense
                                            outlined
                                        >
                                            <template v-slot:label>
                                                <span class="gray--text font-title">
                                                    <i>Provincia *</i>
                                                </span>
                                            </template>
                                        </v-select>
                                    </v-col>
                                    <v-col cols="12" sm="6" class="pt-0">
                                        <v-text-field
                                            v-model="cityReceiver"
                                            :rules="deliveryType =='delivery' ? ruleRequire : []"
                                            outlined
                                            dense
                                            rounded
                                        >
                                            <template v-slot:label>
                                                <span class="gray--text font-title">
                                                    <i>Ciudad *</i>
                                                </span>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" class="pt-0">
                                        <v-text-field
                                            v-model="sectorReceiver"
                                            :rules="deliveryType =='delivery' ? ruleRequire : []"
                                            outlined
                                            dense
                                            rounded
                                        >
                                            <template v-slot:label>
                                                <span class="gray--text font-title">
                                                    <i>Sector *</i>
                                                </span>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" class="pt-0">
                                        <v-text-field
                                            v-model="street1Receiver"
                                            :rules="deliveryType =='delivery' ? ruleRequire : []"
                                            outlined
                                            dense
                                            rounded
                                        >
                                            <template v-slot:label>
                                                <span class="gray--text font-title">
                                                    <i>Calle princial *</i>
                                                </span>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" class="pt-0">
                                        <v-text-field
                                            v-model="street2Receiver"
                                            :rules="deliveryType =='delivery' ? ruleRequire : []"
                                            outlined
                                            dense
                                            rounded
                                        >
                                            <template v-slot:label>
                                                <span class="gray--text font-title">
                                                    <i>Calle secundaria *</i>
                                                </span>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                    
                                    
                                    <v-col cols="12" sm="6" class="pt-0">
                                        <v-text-field
                                            v-model="tlfReceiver"
                                            :rules="deliveryType =='delivery' ? ruleRequire : []"
                                            outlined
                                            dense
                                            rounded
                                        >
                                        <template v-slot:label>
                                            <span class="gray--text font-title">
                                                <i>Teléfono *</i>
                                            </span>
                                        </template>
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" class="pt-0">
                                        <v-textarea 
                                            outlined 
                                            rounded 
                                            v-model="referenceReceiver" 
                                            rows="2"
                                            :rules="deliveryType =='delivery' ? ruleRequire : []"
                                        >
                                            <template v-slot:label>
                                                <span class="gray--text font-title"><i>Refrencias</i></span>
                                            </template>
                                        </v-textarea>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                    </v-row> 
                </v-form>   
                </v-stepper-content>
                <v-stepper-content step="2">
                    <v-btn color="warning" block @click="step = 1"> 
                        <v-icon>mdi mdi-arrow-left-bold-circle</v-icon> REGRESAR A LOS DATOS DE FACTURACIÓN Y ENVÍO 
                    </v-btn>
                    <v-row>
                        <v-col cols="12" md="7">
                            <v-card class="mx-auto">
                                <div class='white--text text-md-subtitle-1 py-2 px-2 primary'>
                                    <b><v-icon class="white--text" style="position: relative;top: -3px;">mdi mdi-cash-multiple</v-icon> FORMAS DE PAGO</b>
                                </div>
                                <v-radio-group
                                    v-model="paymentType"
                                    column
                                    class="ml-3"
                                >
                                    <v-radio value="electronic_transfer">
                                        <template v-slot:label>
                                            <span class="gray--text font-title">
                                                <b><v-icon>mdi mdi-transfer</v-icon> TRANSFERENCIA ELECTRÓNICA</b>
                                            </span>
                                        </template>
                                    </v-radio>
                                    <v-radio value="tdc-td">
                                        <template v-slot:label>
                                            <span class="gray--text font-title">
                                                <b> <v-icon>mdi mdi-credit-card</v-icon> TARJETA DE CRÉDITO / DÉBITO</b>
                                            </span>
                                        </template>
                                    </v-radio>
                                </v-radio-group>
                                <v-card-text>
                                    <div v-if="paymentType=='electronic_transfer'">
                                        <div class='white--text text-md-subtitle-1 py-2 px-2 primary'>
                                            <b><v-icon class="white--text" style="position: relative;top: -3px;">mdi mdi-bank</v-icon> CUENTA BANCARIA</b>
                                        </div>
                                        <div class="mt-3">
                                            <v-select
                                                v-model="bankSelected"
                                                :items="bankAccountsData"
                                                item-value="fin_account_id"
                                                item-text="fin_account_name"
                                                prepend-inner-icon="mdi-format-list-bulleted"
                                                label="Bancos disponibles"
                                                dense
                                                outlined
                                                class="px-3"
                                                :hide-details=true                                                
                                                @change="changeBankAccount"
                                            ></v-select>
                                        </div>
                                        <ul>
                                            <li> <b>Número:</b> {{numberAccountBank}}</li>
                                            <li> <b>Titular:</b>{{ownerAccountBank}}</li>
                                            <li> <b>Identificación:</b> {{identificationAccountBank}}</li>
                                            <li> <b>Correo:</b> {{emailAccountBank}}</li>                                                
                                        </ul>
                                        <div class="px-3 mt-2">
                                            <v-text-field
                                                outlined
                                                dense
                                                label="DIGÍTE LA REFERENCIA DE LA TRANSFERENCIA AQUÍ"
                                                @click:append="createQuote"
                                                class=""
                                            ></v-text-field>
                                            <v-btn 
                                                color="success" 
                                                block
                                                class="px-5"
                                            >
                                                <v-icon class="mr-2">mdi mdi-send</v-icon> REALIZAR COMPRA 
                                            </v-btn>
                                        </div>
                                    </div>
                                    <div v-else>
                                        INTEGRAR PLACE TO PAY
                                    </div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="5">
                            <v-card class="mx-auto">
                                <div class='gray--text text-md-subtitle-1 primary py-2 px-2'>
                                    <b class="white--text">
                                        <v-icon class="white--text" style="position: relative;top: -3px;">mdi mdi-cart-outline</v-icon> SUS PRODUCTOS
                                    </b>
                                </div>
                                <div v-if="shoppingCar.length">
                                    <div v-for="(sc, x) in shoppingCar"
                                        :key="x"
                                        style="border: 2px solid silver; border-radius: 10px"
                                        class="my-2"
                                    >
                                        <v-col class="d-flex align-center flex-column flex-sm-row">
                                            <v-col
                                                class="text-caption text-md-body-2"
                                                v-html="`<b>${sc.internal_name} X ${sc.quantity}</b>`"
                                            >
                                            </v-col>
                                            <v-col class="text-center px-0">
                                                <div
                                                    style="border: 2px solid #50c995"
                                                    class="rounded-xl text-caption"
                                                >
                                                    <v-icon
                                                        class="primary--text px-2"
                                                        @click="quantity('-', sc.product_id)"
                                                    >mdi-minus mdi-18px
                                                    </v-icon>
                                                        <span class="font-weight-bold gray--text"><b>{{sc.quantity}}</b></span>
                                                    <v-icon
                                                        class="primary--text px-2"
                                                        @click="quantity('+', sc.product_id)"
                                                    >mdi-plus mdi-18px
                                                    </v-icon>
                                                </div>
                                            </v-col>
                                            <v-col class="text-center px-0">
                                                <v-btn icon @click="removeItemShopping(sc)">
                                                    <v-icon class="red--text">mdi-delete-forever</v-icon>
                                                </v-btn>
                                            </v-col>
                                        </v-col>
                                    </div>
                                </div>
                                <div v-else class="text-md-h6 gray--text">
                                    <v-icon>mdi-alert-circle</v-icon> Sin productos agregados
                                </div>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions } from "vuex";
import axios from "axios";
import Vue from "vue";

export default {
  name: "ProdcutsCheckoutComponent",

    data: () => ({
        ruleRequire: [(v) => !!v || "El campo es obligatorio"],
        breadcrumb: { 
            name: "Servicio", 
            url: "servicios" 
        },
        selectProduct: {
            product_id: null,
            quantity: 0,
            product_name: "",
        },
        identification:null,
        firstName: null,
        lastName: null,
        email: null,
        tlf: null,
        deliveryTypes:[
            {type: 'delivery', name:'ENTREGA A DOMICILIO'},
            {type: 'pickup', name: 'RETIRAR EN TIENDA'}
        ],
        deliveryType:'delivery',
        iconTypeDelivey: 'mdi mdi-truck',
        firstNameReceiver: null,
        lastNameReceiver: null,
        emailReceiver: null,
        tlfReceiver: null,
        sectorReceiver:null,
        street1Receiver:null,
        street2Receiver:null,
        provinceReceiver:null,
        directionReceiver:null,
        cityReceiver:null,
        address: null,
        city: null,
        referenceReceiver: null,
        referenceTransfer:null,
        step: 1,
        identificationType:null,
        bankSelected:null,
        ownerAccountBank:null,
        emailAccountBank:null,
        identificationAccountBank:null,
        numberAccountBank:null,
        paymentType:'electronic_transfer',
        directionsClient:[],
        bankAccountsData:[],
        provinces:[],
        identificationTypes:[
            {name:'CEDULA'},
            {name: 'PASAPORTE'},
            {name: 'RUC'}
        ],
        selectedProducts: [],
        files: [],
    }),
    computed: {

        menuMovil() {
            return (
                this.$vuetify.breakpoint.name == "sm" ||
                this.$vuetify.breakpoint.name == "xs"
            );
        },

        ...mapState([
            "shoppingCar",
            "token",
            "url",
            "directoryFileQuote",
            "urlApi",
            "pathFileProducts",
        ])

    },
    methods: {

        ...mapMutations([
        "setCheckout",
        "setTotalQuantity",
        "itemShoppingCar",
        "setLoadingTable",
        "setUrl",
        ]),

        ...mapActions(["alertNotification","requestApi"]),

        setFile(file) {
        this.files = file;
        },

        storeWorkEffort() {

            if (!this.$refs.form_billing_data.validate()) return false;

            let params = {};
            let arr = [];
            this.setLoadingTable(true);
            this.setUrl("work-effort");
            let formData = new FormData();
            formData.append("firstName", this.firstName);
            formData.append("lastName", this.lastName);
            formData.append("email", this.email);
            formData.append("tlf", this.tlf);
            formData.append("address", this.address);
            formData.append("city", this.city);
            formData.append("reference", this.reference);
            formData.append("directory", this.directoryFileQuote);
            formData.append("products", JSON.stringify(this.shoppingCar));
            this.files.map((data, x) => {
                formData.append("file_" + x, data);
                arr.push(data);
            })

            axios.post(this.url, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: "Bearer " + this.token,
                },
            }).then((res) => {
                
                params = {
                    title: res.data.detail,
                    html: "Muchas gracias, le responderemos en breve.",
                    icon: "success",
                    confirmButtonColor: "#50c995",
                    toast: false,
                    grow: false,
                    position: "center",
                    confirmButtonText: "Cerrar",
                }

                this.itemShoppingCar([]);
                this.firstName = null
                this.lastName = null
                this.email = null
                this.tlf = null
                this.address = null
                this.city = null
                this.reference = null
                this.files = []

            }).catch((err) => {
            console.log(err)

            params = {
                title: "Error!",
                html: err.data.detail,
                icon: "error",
                confirmButtonColor: "#d60400",
                toast: false,
                grow: false,
                position: "center",
                confirmButtonText: "Cerrar",
            }

            }).then(() => {

            Vue.swal({ ...params })

            })
        },

        quantity(operator, product_id) {
        let products = this.shoppingCar;
        let itemExist = products.find((e) => e.product_id == product_id);

        if (typeof itemExist != "undefined") {
            let index = products.indexOf(itemExist);

            if (operator == "+") {
            products[index].quantity += 1;
            } else {
            if (products[index].quantity) {
                products[index].quantity -= 1;
            }
            }
        }

        this.itemShoppingCar(products);
        },

        removeItemShopping(product) {

            let products = this.shoppingCar;
            let obj = products.find((e) => e.product_id == product.product_id)

            if (typeof obj != "undefined") {
                console.log(products)
                let index = products.indexOf(obj)
                products.splice(index, 1)
                this.itemShoppingCar([])
                localStorage.setItem("shoppingCar", products)
                this.itemShoppingCar(products)
            }

        },

        searchClient(){

            this.setUrl(`buscar-cliente/${this.identification}`);
            this.requestApi({
                method: 'GET',
                data: {}
            }).then(res=>{
                console.log(res)
                this.provinces = res.data.provinces

                if(res.data.person != null){

                    const {
                        first_name,
                        last_name, 
                        email, 
                        phone, 
                        directions, 
                        party_identification_type_id,
                    } = res.data.person

                    this.firstName = first_name
                    this.lastName = last_name
                    this.email = email != null ? email.info_string : ''
                    this.tlf = phone.phone
                    this.directionsClient = directions
                    this.identificationType = party_identification_type_id

                    this.firstNameReceiver = first_name
                    this.lastNameReceiver = last_name
                    this.tlfReceiver = phone.phone
                    
                    if(directions.length){

                        this.directionReceiver = directions[0].contact_mech_id
                        this.referenceReceiver = directions[0].reference
                        this.sectorReceiver= directions[0].sector
                        this.street1Receiver= directions[0].address1
                        this.street2Receiver= directions[0].calle_secundaria
                        this.cityReceiver = directions[0].city
                        this.provinceReceiver= directions[0].geo_id

                    }

                }else{

                    this.firstName= null
                    this.lastName= null
                    this.email= null
                    this.tlf= null
                    this.identificationType = null
                    this.directionsClient=[]
                    
                }
                
            })

        },

        setDirectionInputs(){

            let objDirection = this.directionsClient.find(e => e.contact_mech_id == this.directionReceiver)
            this.directionReceiver = objDirection.contact_mech_id
            this.referenceReceiver = objDirection.reference
            this.sectorReceiver= objDirection.sector
            this.street1Receiver= objDirection.address1
            this.street2Receiver= objDirection.calle_secundaria
            this.cityReceiver = objDirection.city
            this.provinceReceiver= objDirection.geo_id


        },

        validDatashipping(){

            if (this.$refs.form_billing_data.validate())
                this.step= 2

        },//1001859501

        getBankAccountData(){

            this.setUrl('busqueda-catalogo/1')
            this.requestApi({
                method: 'PUT',
                data :{}
            }).then(res =>{
                
                this.bankAccountsData = res.data.cuentas

                if(this.bankAccountsData.length){
                    this.bankSelected= this.bankAccountsData[0].fin_account_id
                    this.changeBankAccount()
                }

            })

        },

        changeBankAccount(){

            let objBankAccount = this.bankAccountsData.find(e => e.fin_account_id == this.bankSelected)

            const { account_number, owner, owner_identification, owner_mail } = objBankAccount

            this.ownerAccountBank=owner
            this.emailAccountBank= owner_mail
            this.identificationAccountBank= owner_identification
            this.numberAccountBank= account_number

        },

        createQuote(){

        }

    },
    created(){

        this.getBankAccountData()

    }
}
</script>

<style scope>
form fieldset {
  border: 2px solid #ffaa45 !important;
}
.form-text-area > div > div > fieldset {
  border: 2px solid #c9c7c7 !important;
}

.swal2-title {
  color: #50c995;
  font-family: "Asap";
  font-size: 23px;
}

.swal2-html-container {
  font-family: "Asap";
  color: "#c9c7c7";
}

.swal2-confirm {
  font-family: "Asap";
}

.swal2-success-ring,
.swal2-success-line-long,
.swal2-success-line-tip,
.swal2-icon,
.swal2-success {
  color: #50c995 !important ;
}

form.form_billing_data fieldset{
    border-radius: 20px;
}

@media (max-width: 1280px) and (min-width: 960px) {
  .col-md1-5 {
    flex: 0 0 14.3333333333% !important;
    max-width: 14.3333333333% !important;
  }
}
</style>
